import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Mon1.png";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        "/api/users/login/",
        { username, password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        localStorage.setItem("accessToken", response.data.access);
        localStorage.setItem("refreshToken", response.data.refresh);
        navigate("/dashboard");
      } else {
        setError(response.data.message || "Invalid credentials");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Please try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
        gap: "24px",
        alignItems: "center",
        padding: "24px",
      }}
    >
      <section
        style={{
          minHeight: "min(720px, calc(100vh - 48px))",
          padding: "40px",
          borderRadius: "32px",
          color: "#fff",
          background:
            "radial-gradient(circle at top right, rgba(99,199,255,0.32), transparent 28%), linear-gradient(135deg, #102a71 0%, #17388f 45%, #2f6fe4 100%)",
          boxShadow: "0 30px 60px rgba(16,42,113,0.25)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div
            style={{
              display: "inline-flex",
              padding: "8px 14px",
              borderRadius: "999px",
              background: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.15)",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
            }}
          >
            ISO Control Center
          </div>

          <h1 style={{ margin: "24px 0 12px", fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
            Manage compliance work with a cleaner, sharper workspace.
          </h1>

          <p
            style={{
              margin: 0,
              maxWidth: "560px",
              color: "rgba(255,255,255,0.82)",
              fontSize: "1.02rem",
              lineHeight: 1.8,
            }}
          >
            Track ISO actionables, policy reviews, exception reports, and mandated
            meetings from a modern dashboard designed for clarity and control.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: "14px",
          }}
        >
          {[
            { label: "Actionables", value: "Live tracking" },
            { label: "Policies", value: "Centralized access" },
            { label: "Reports", value: "Export-ready views" },
          ].map((item) => (
            <div
              key={item.label}
              style={{
                padding: "18px",
                borderRadius: "22px",
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.14)",
              }}
            >
              <div style={{ fontSize: "0.82rem", opacity: 0.8 }}>{item.label}</div>
              <div style={{ marginTop: "8px", fontSize: "1.1rem", fontWeight: 700 }}>
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          width: "min(100%, 460px)",
          margin: "0 auto",
          padding: "36px",
          borderRadius: "32px",
          background: "rgba(255,255,255,0.92)",
          border: "1px solid rgba(16,42,113,0.08)",
          boxShadow: "0 24px 50px rgba(15,23,42,0.12)",
          backdropFilter: "blur(16px)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <img
            src={logo}
            alt="Company Logo"
            style={{ width: "116px", height: "116px", objectFit: "contain", margin: "0 auto 16px" }}
          />
          <h2 style={{ margin: 0, fontSize: "2rem", color: "#102a71" }}>Welcome back</h2>
          <p style={{ margin: "10px 0 0", color: "#65748f", lineHeight: 1.7 }}>
            Sign in to continue managing ISO tasks and review activity.
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: "grid", gap: "14px" }}>
          {error && (
            <p style={{ margin: 0, padding: "12px 14px" }} className="error-text">
              {error}
            </p>
          )}

          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: 700, color: "#3a4b6d" }}>
              Username
            </label>
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: 700, color: "#3a4b6d" }}>
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="primary-btn" style={{ marginTop: "8px" }}>
            Login
          </button>
        </form>
      </section>
    </div>
  );
};

export default Login;
